export default __webpack_public_path__ + "static/media/icn_no.ed156ed6.svg";